export const SELECT_ALL = 'select_all';

export const DEFAULT_METRICS = {
  primary: ['product_sales', 'sessions'],
  secondary: ['units'],
  tertiary: ['conversionRate']
};

export const DEFAULT_METRICS_LIST = [
  'units',
  ...DEFAULT_METRICS.primary,
  ...DEFAULT_METRICS.secondary,
  ...DEFAULT_METRICS.tertiary
];
export const TOTAL_ADS_METRIC_API_NAME = 'total_ads';
export const ANALYTICS_CHART_INTERVAL = 'Daily';
export const CurrencyAxisTickFormatter = value => `$${value}`;

export const TOTALS_DEFAULT_METRICS = ['sessions', 'product_sales', 'units', 'conversionRate'];
export const TOTALS_COLUMNS_SETTINGS_ID = 'analytics-totals_v2';
export const CAMPAIGNS_STATS_COLUMNS_SETTINGS_ID = 'analytics-campaigns-stats';
export const TOTALS_ROW_TYPE = 'TOTALS_ROW_TYPE';
